// extracted by mini-css-extract-plugin
export default {"AvailableSensors":"AvailableSensors_AvailableSensors__Nsvc5"};